import {
    GET_ROLE_REQUEST, GET_ROLE_SUCCESS, GET_ROLE_FAIL,
    GET_ALL_ROLES_REQUEST, GET_ALL_ROLES_SUCCESS, GET_ALL_ROLES_FAIL,
    GET_ACTIVE_ROLES_REQUEST, GET_ACTIVE_ROLES_SUCCESS, GET_ACTIVE_ROLES_FAIL,
    GET_ROLES_BY_MODULE_REQUEST, GET_ROLES_BY_MODULE_SUCCESS, GET_ROLES_BY_MODULE_FAIL,
    GET_GLOBAL_ROLES_REQUEST, GET_GLOBAL_ROLES_SUCCESS, GET_GLOBAL_ROLES_FAIL,
    CREATE_ROLE_REQUEST, CREATE_ROLE_SUCCESS, CREATE_ROLE_FAIL,
    UPDATE_ROLE_REQUEST, UPDATE_ROLE_SUCCESS, UPDATE_ROLE_FAIL,
    DELETE_ROLE_REQUEST, DELETE_ROLE_SUCCESS, DELETE_ROLE_FAIL,
    SET_SELECTED_ROLE, SET_ROLE_LOADING
} from '../actions/roleActions';
import {
    readNavigationSelection,
    saveNavigationSelectionForRole,
} from '../../utils/navigationSelectionStorage';

const persistedSelection = readNavigationSelection();

const initialState = {
    roles: [],
    currentRole: null,
    selectedRole: persistedSelection?.role || null,
    loading: false,
    message: '',
    error: null
};

function roleReducer(state = initialState, action) {
    switch (action.type) {
        case SET_SELECTED_ROLE:
            saveNavigationSelectionForRole(action.payload, action.payload?.userId);
            return {
                ...state,
                selectedRole: action.payload
            };

        case SET_ROLE_LOADING:
            return {
                ...state,
                loading: action.payload
            };

        case GET_ROLE_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };
        case GET_ROLE_SUCCESS:
            return {
                ...state,
                currentRole: action.payload,
                loading: false,
                message: 'Role recupere avec succes'
            };
        case GET_ROLE_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error
            };

        case GET_ALL_ROLES_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };
        case GET_ALL_ROLES_SUCCESS:
            return {
                ...state,
                roles: action.payload,
                loading: false,
                message: ''
            };
        case GET_ALL_ROLES_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error
            };

        case GET_ACTIVE_ROLES_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };
        case GET_ACTIVE_ROLES_SUCCESS:
            return {
                ...state,
                roles: action.payload,
                loading: false,
                message: 'Roles actifs recuperes avec succes'
            };
        case GET_ACTIVE_ROLES_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error
            };

        case GET_ROLES_BY_MODULE_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };
        case GET_ROLES_BY_MODULE_SUCCESS:
            return {
                ...state,
                roles: action.payload,
                loading: false,
                message: 'Roles filtres par module avec succes'
            };
        case GET_ROLES_BY_MODULE_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error
            };

        case GET_GLOBAL_ROLES_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };
        case GET_GLOBAL_ROLES_SUCCESS:
            return {
                ...state,
                roles: action.payload,
                loading: false,
                message: 'Roles globaux recuperes avec succes'
            };
        case GET_GLOBAL_ROLES_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error
            };

        case CREATE_ROLE_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };
        case CREATE_ROLE_SUCCESS:
            return {
                ...state,
                roles: [...state.roles, action.payload],
                loading: false,
                message: 'Role cree avec succes'
            };
        case CREATE_ROLE_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error
            };

        case UPDATE_ROLE_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };
        case UPDATE_ROLE_SUCCESS:
            return {
                ...state,
                roles: state.roles.map(role =>
                    role.id === action.payload.id ? action.payload : role
                ),
                currentRole: state.currentRole?.id === action.payload.id
                    ? action.payload
                    : state.currentRole,
                loading: false,
                message: 'Role mis a jour avec succes'
            };
        case UPDATE_ROLE_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error
            };

        case DELETE_ROLE_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };
        case DELETE_ROLE_SUCCESS:
            return {
                ...state,
                roles: state.roles.filter(role => role.id !== action.payload.roleId),
                currentRole: state.currentRole?.id === action.payload.roleId
                    ? null
                    : state.currentRole,
                loading: false,
                message: 'Role supprime avec succes'
            };
        case DELETE_ROLE_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error
            };

        default:
            return state;
    }
}

export default roleReducer;
